(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["twice-pdp-design"] && !Shopify.designMode) return;
  try {
    (() => {
  const initPreviewClearance = () => {
    if (!document.querySelector('.section-product-page [id^="MainProduct-"] .sticky-cta')) return;
    const root = document.documentElement;
    let wrapper = null;
    let frame = 0;
    let lastClearance = -1;
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(measure);
    };
    const resizeObserver = new ResizeObserver(schedule);
    const attributeObserver = new MutationObserver(schedule);
    const measure = () => {
      frame = 0;
      // Shopify's iframe fills the viewport; its wrapper is the visible toolbar.
      const nextWrapper = document.getElementById('PBarNextFrameWrapper');
      if (nextWrapper !== wrapper) {
        resizeObserver.disconnect();
        attributeObserver.disconnect();
        wrapper = nextWrapper;
        if (wrapper) {
          resizeObserver.observe(wrapper);
          attributeObserver.observe(wrapper, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
        }
      }
      let clearance = 0;
      if (wrapper) {
        const rect = wrapper.getBoundingClientRect();
        const style = getComputedStyle(wrapper);
        if (rect.height > 0 && rect.width > 0 && style.visibility !== 'hidden' && style.display !== 'none' && rect.bottom >= window.innerHeight - 1) {
          clearance = Math.ceil(Math.max(0, Math.min(rect.height, window.innerHeight - rect.top)));
        }
      }
      if (clearance !== lastClearance) {
        root.style.setProperty('--tw-preview-clearance', clearance + 'px');
        lastClearance = clearance;
      }
    };
    // The preview toolbar can arrive after the storefront has finished loading.
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);
    measure();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPreviewClearance, { once: true });
  } else {
    initPreviewClearance();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["twice-product-copy"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){const link=event.target.closest('[data-tw-open-use]');if(!link)return;const details=link.closest('product-info')?.querySelector('#twice-use-details');if(details)details.open=true;});
  } catch(e) { console.error(e); }
})();

})();
